// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__UPOfU","wrapper":"style__wrapper__XbznH"};